<mf-page title="Editar incidente">
  <mf-issue
    [issueDto]="issueDto"
    [edit]="true"
    (save)="save($event)" />
</mf-page>
